import axios from 'axios'
import { getToken } from '@/utils/auth'
import { ElMessage } from 'element-plus'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '/api',
  timeout: 10000 // 请求超时时间
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    const token = getToken()
    if (token) {
      // 让每个请求携带token
      config.headers['Authorization'] = 'Bearer ' + token
    }
    
    // 设置默认请求头
    config.headers['Content-Type'] = 'application/json;charset=UTF-8'
    config.headers['Accept'] = 'application/json'
    
    return config
  },
  error => {
    // 对请求错误做些什么
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 对响应数据做点什么
    const res = response.data
    
    // 判断响应码
    if (res.code === 200 || res.code === 0) {
      return res.data
    } else if (res.code === 401) {
      // 未授权，跳转到登录页
      ElMessage.error({
        message: res.msg || res.message || '登录已过期，请重新登录',
        duration: 3000
      })
      // 清除token并跳转到SSO中转页
      localStorage.clear()
      window.location.href = '/sso'
      return Promise.reject(new Error(res.msg || res.message || 'Error'))
    } else if (res.code === 403) {
      // 权限不足
      ElMessage.error({
        message: res.msg || res.message || '权限不足，无法访问',
        duration: 3000
      })
      return Promise.reject(new Error(res.msg || res.message || 'Error'))
    } else {
      // 其他错误
      ElMessage.error({
        message: res.msg || res.message || '请求失败',
        duration: 3000
      })
      return Promise.reject(new Error(res.msg || res.message || 'Error'))
    }
  },
  error => {
    // 对响应错误做点什么
    console.error('响应错误:', error)
    
    if (error.response) {
      // 请求已发出，但服务器响应的状态码不在 2xx 范围内
      const { status, data } = error.response
      
      switch (status) {
        case 400:
          ElMessage.error({
            message: data.msg || data.message || '请求参数错误',
            duration: 3000
          })
          break
        case 401:
          ElMessage.error({
            message: data.msg || data.message || '登录已过期，请重新登录',
            duration: 3000
          })
          // 清除token并跳转到SSO中转页
          localStorage.clear()
          window.location.href = '/sso'
          break
        case 403:
          ElMessage.error({
            message: data.msg || data.message || '权限不足，无法访问',
            duration: 3000
          })
          break
        case 404:
          ElMessage.error({
            message: data.msg || data.message || '请求的资源不存在',
            duration: 3000
          })
          break
        case 500:
          ElMessage.error({
            message: data.msg || data.message || '服务器内部错误',
            duration: 3000
          })
          break
        case 502:
          ElMessage.error({
            message: '网关错误',
            duration: 3000
          })
          break
        case 503:
          ElMessage.error({
            message: '服务不可用',
            duration: 3000
          })
          break
        case 504:
          ElMessage.error({
            message: '网关超时',
            duration: 3000
          })
          break
        default:
          ElMessage.error({
            message: data.msg || data.message || `请求错误: ${status}`,
            duration: 3000
          })
      }
    } else if (error.request) {
      // 请求已发出，但没有收到响应
      ElMessage.error({
        message: '网络连接失败，请检查网络设置',
        duration: 3000
      })
    } else {
      // 发送请求时发生了一些错误
      ElMessage.error({
        message: error.message || '请求错误',
        duration: 3000
      })
    }
    
    return Promise.reject(error)
  }
)

export default service